import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface DateDivProps {
  width?: number;
  height?: number;
  borderColor?: string;
}
export const DateDiv = styled.div<DateDivProps>`
  font-family: 'Poppins', sans-serif;
  & .MuiInputBase-root {
    width: ${({ width }) => width || '220'}px;
    display: flex;
    align-items: center;
    font-family: 'Poppins', sans-serif;
    height: ${({ height }) => height || '40'}px;
    border-radius: 8px;
    font-size: 14px;
    color: ${beam.font.primary};
    background: #fff;
    padding-left: 10px;
    border: 1px solid ${({ borderColor }) => borderColor || '#e9edf1'};
    box-sizing: border-box;
    & .MuiInputBase-input {
      display: flex;
      font-size: 14px;
      justify-items: center;
      justify-content: center;
    }
    & .MuiSvgIcon-root {
      height: 18px;
      width: 18px;
    }
  }

  & .MuiFormHelperText-root.Mui-error {
    position: absolute;
    bottom: -18px;
    margin-left: 10px;
    color: transparent;
  }
`;
